module.exports = __webpack_public_path__ + "img/guihua.7c4b3ff5.jpg";